import { useLingui } from "@lingui/react/macro";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@orbin/ui-web";
import { PaymentCheckout } from "./PaymentCheckout";

/** Adds credit in context, without leaving the screen that ran out. */
export function RechargeDialog({
  open,
  onOpenChange,
  onPaid,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onPaid?: () => void;
}) {
  const { t } = useLingui();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm" data-testid="recharge-dialog">
        <DialogHeader>
          <DialogTitle>{t`Add credit`}</DialogTitle>
          <DialogDescription className="sr-only">{t`Choose how to pay`}</DialogDescription>
        </DialogHeader>
        {open ? <PaymentCheckout onPaid={onPaid} /> : null}
      </DialogContent>
    </Dialog>
  );
}
